export default __webpack_public_path__ + "static/media/icon_popup_registo_removido.e7a400d1.svg";